import { Action } from '@wix/component-protocol/schema';
import { filterByTags, shouldBeExcludedFromEditActions } from './utils';
import { IEditActionBuilder, IEditActionSource } from './types';

export class EditActionsFactory<TActionNames extends string = string> {
  constructor(
    private readonly editActionSource: IEditActionSource<TActionNames>,
    private readonly editActionBuilder: IEditActionBuilder<TActionNames>,
    private readonly tags?: string[],
  ) {}

  create() {
    const definitions = this.editActionSource.getDefinitions();

    const actions = (Object.entries(definitions) as [TActionNames, Action][])
      .map(([actionName, actionDefinition]) =>
        this.editActionBuilder.build(actionName, actionDefinition),
      )
      .filter((action) => action !== null)
      .filter((action) => !shouldBeExcludedFromEditActions(action));

    return filterByTags(actions, this.tags);
  }
}
